export const language: any = {
  title: '食材',
  select_all: '全选',
  deselect_all: '取消全选',
  add: '添加食材',
  add_title: '请选择添加食材的方式。',
  add_by_list: '添加食材',
  add_total: '总共添加 {number} 种食材',
  selecting: '选择食材总数',
  filter_title: '筛选排序',
  filter_newest: '最新',
  filter_oldest: '最早',
  filter_alphabet: '按字母顺序',
  get_recipe: '获取 AI 烹饪推荐',
  search_placeholder: '请输入搜索内容。',
  nodata: '没有相关食材。',
  request: '添加食材',
  recipe_title: '推荐菜品',
  option: {
    title: '食材',
    desc: '选择此选项不是必需的。',
    complete: '完成',
    reset: '重置',
  },
  msg: {
    msg_7: "是否添加选中的食材？",
    msg_8: `
      <p>是否添加选中的食材？</p>
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> 已经包含在现有食材中，因此被排除在外。)</p>
    `,
    msg_9: "是否将选中的食材添加到购物车？",
    msg_10: `
      <p>是否将选中的食材添加到购物车？<br />
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> 已经包含在现有食材中，因此被排除在外。)</p>
    `,
    confirm: '添加',
    cancel: '取消',
    not_ingredient: '您輸入的內容似乎不是食材。<br />請重新確認。',
    ai_failed: '輸入食材時發生錯誤。<br />請再試一次。',
    ingredient_exist_should_exclued: `(<span class="text-primary">{name}</span> 已经包含在现有食材中，因此被排除在外。)`,
  },
  history: "图像分析历史",
  myIngredient: "我的食材",
  history_no_data: "没有历史记录",
  history_take_photo: "拍照或选择照片",
}
